import * as log from "loglevel";
import { isAppEnvLocal, isPageInDebugMode } from "./utils";
log.setDefaultLevel("error");

if (isPageInDebugMode() || isAppEnvLocal()) {
  log.setDefaultLevel("trace");
}

export default log;
